import type { TAvailableLanguageCodes } from '@hubertai/screening-question-types';
import type { TTextBubbleItem } from 'components/TextBubbleDragAndDrop';
import { LanguageExpandableText } from 'components/Rules/LanguageExpandableText';

interface Props {
  availableLanguages: TAvailableLanguageCodes[];
  textByLanguage: Partial<Record<TAvailableLanguageCodes, TTextBubbleItem[]>>;
}

export const QuestionTextPreview = ({ availableLanguages, textByLanguage }: Props) => (
  <LanguageExpandableText
    availableLanguages={availableLanguages}
    renderText={(language) =>
      (textByLanguage[language] ?? []).map((line) => (
        <i key={line.id} className="text-wrap" dangerouslySetInnerHTML={{ __html: line.text ?? '' }} />
      ))
    }
  />
);
